import { on, fire } from 'delegated-events'
import { handleValidation, handleBlur } from '../common/validation'
import scrollTo from '../common/scrollTo'

const $toggleForm = document.querySelector('form.has-toggles')

const fn = {
  init: () => {
    on('blur', '.has-error', handleBlur, { capture: true })
    on('change', '.has-error', handleBlur, { capture: true })
    on('change', '.has-error blur', handleBlur, {
      capture: true,
    })
    on('keyup', 'textarea.has-length-limit', fn.handleLengthLimit, {
      capture: true,
    })
    on('submit', '[data-form-validate]:not(.multistepform)', (e) => handleValidation(e.target))
    on('submit', '[data-form-ajax]', fn.handleAjax)
    on('change', '.form-all-group input[type="checkbox"]', fn.handleAllGroup)
    on('click', '.radio-group', fn.handleRadios)
    on('change', 'input[type=radio]', fn.handleToggle)
    on('change', 'input[type=checkbox]', fn.handleToggle)
    on('keyup', '.toggle-source-gt input[type=text]', fn.handleToggle)

    fn.showToggles()
    fn.setupSpecialFields()
    fn.setupUserForms()
    fn.setupMasks(document.querySelector('form'))
  },

  setupUserForms: () => {
    const $uf = document.querySelectorAll('.userform')
    if ($uf.length) {
      const $userform = $uf[0]
      const $reqs = $userform.querySelectorAll('.field.requiredField')
      $reqs.forEach(($fieldWrap) => {
        var $label
        if ($fieldWrap.classList.contains('userformsoptionset')) {
          $label = $fieldWrap.getElementsByTagName('legend')
        } else {
          $label = $fieldWrap.getElementsByTagName('label')
        }
        $label[0].innerHTML = $label[0].innerHTML + ' <sup>*</sup>'
      })
      const $prevButtons = $userform.querySelectorAll('.step-button-prev')
      const $nextButtons = $userform.querySelectorAll('.step-button-next')
      $prevButtons.forEach(($button) => {
        $button.addEventListener('click', () => {
          var $requireds = $userform.querySelectorAll('.error')
          if ($requireds.length == 0) {
            scrollTo($userform)
          }
        })
      })
      $nextButtons.forEach(($button) => {
        $button.addEventListener('click', () => {
          var $requireds = $userform.querySelectorAll('.error')
          if ($requireds.length == 0) {
            scrollTo($userform)
          }
        })
      })
    }
  },

  setupSpecialFields: () => {
    document.querySelectorAll('form').forEach(($form) => {
      // Setup length limits
      $form.querySelectorAll('.form-field-wrapper.has-length-limit').forEach(($field) => {
        const $input = $field.querySelector('.has-length-limit')

        if ($input && $input.maxLength) {
          const $label = $field.querySelector('label')
          $label.classList.add('has-length-limit')

          const $counter = document.createElement('div')
          $counter.classList.add('length-limit-counter')

          const $count = document.createElement('span')
          $count.textContent = `(${$input.value.length}/${$input.maxLength})`

          $counter.appendChild($count)

          const $labelHolder = document.createElement('div')

          $labelHolder.classList.add('form-field-label')
          $labelHolder.appendChild($label.cloneNode(true))
          $labelHolder.appendChild($counter)

          $label.replaceWith($labelHolder)
        }
      })
    })
  },

  handleLengthLimit: (e) => {
    const $input = e.target.closest('.has-length-limit')
    const $field = $input.closest('.field.has-length-limit')

    if ($input && $field) {
      const $count = $field.querySelector('.length-limit-counter span')
      $count.textContent = `(${$input.value.length}/${$input.maxLength})`
    }
  },

  handleAllGroup: (e) => {
    const isAll = e.target.value === 'All'
    const group = e.target.closest('.form-all-group')

    if (group) {
      const allEl = group.querySelector('input[value="All"]')

      if (allEl && isAll) {
        if (allEl.checked) {
          group.querySelectorAll('[type="checkbox"]').forEach((x) => (x.checked = true))
        } else {
          group.querySelectorAll('[type="checkbox"]').forEach((x) => (x.checked = false))
        }
      }

      if (allEl && !isAll) {
        allEl.checked = false
      }
    }
  },

  handleRadios: (e) => {
    const $input = e.target
    const $holder = $input.closest('[role="option"]')
    const $siblings = fn.getSiblings($holder)

    if ($input && $holder) {
      $holder.classList.add('checked')

      if ($siblings.length) {
        $siblings.forEach(($sibling) => {
          $sibling.classList.remove('checked')
        })
      }
    }
  },

  getSiblings: (e) => {
    let siblings = []
    if (!e.parentNode) {
      return siblings
    }
    let sibling = e.parentNode.firstChild
    while (sibling) {
      if (sibling.nodeType === 1 && sibling !== e) {
        siblings.push(sibling)
      }
      sibling = sibling.nextSibling
    }
    return siblings
  },

  handleAjax: (e) => {
    e.preventDefault()

    const $form = e.target
    const isValid = handleValidation($form)

    if (isValid) {
      const $formMessages = $form.querySelector('.form-messages')
      const $submitButton = $form.querySelector('[type=submit]')
      let autoHideMessage = true
      fn.toggleSubmit($submitButton)

      const formData = new FormData($form)

      ajax
        .url($form.action)
        .body(formData)
        .post()
        .json((res) => {
          if (res.success) {
            $form.reset()
            $form.querySelectorAll('select').forEach((x) => (x.value = null))
            $form.querySelectorAll('.file-input-placeholder').forEach((x) => x.classList.add('is-hidden'))
            $form.querySelectorAll('.toggle-fields').forEach((x) => x.classList.add('hidden'))
            $form.querySelectorAll('.toggle-group').forEach((x) => x.classList.add('hidden'))
            $form.querySelectorAll('textarea.has-length-limit').forEach((el) => {
              fn.handleLengthLimit({ target: el })
            })

            if ($form.dataset.hideOnSubmit) {
              $form.querySelectorAll('.form-content').forEach((x) => x.classList.add('hidden'))
              autoHideMessage = false
            }

            fire(document.documentElement, 'ajaxform:submit', {
              type: 'post',
              url: new URL($form.action),
              queryParameters: new URLSearchParams(formData).toString(),
            })
          }

          if (res.message) {
            fn.showFormMessages($formMessages, res.message, res.success, autoHideMessage)
          }
        })
        .catch(() => {
          fn.showFormMessages($formMessages, 'Sorry, there was a problem with your submission')
        })
        .finally(() => {
          fn.toggleSubmit($submitButton)
        })
    }
  },

  toggleSubmit: ($submitButton) => {
    $submitButton.disabled = !$submitButton.disabled
    $submitButton.classList.toggle('btn-loading')
  },

  showFormMessages: ($holder, message, success, autoHide) => {
    $holder.style.display = 'block'
    $holder.innerHTML = message

    if (success) {
      $holder.classList.remove('form-message-error')
    } else {
      $holder.classList.add('form-message-error')
    }

    if (autoHide) {
      setTimeout(() => {
        $holder.style.display = 'none'
      }, 5000)
    }
  },

  showToggles: () => {
    if ($toggleForm) {
      $toggleForm.querySelectorAll(`[data-toggle-if]`).forEach(($input) => {
        const $targetEl = $toggleForm.querySelector(`[name="${$input.dataset.toggleIf.split('|')[0]}"]:checked`)
        const targetValues = $input.dataset.toggleIf.split('|')
        targetValues.shift()
        const $toggleGroup = $input.closest('.toggle-group')

        if ($targetEl && targetValues.indexOf($targetEl.value) !== -1) {
          $toggleGroup.classList.remove('hidden')
        }
      })

      $toggleForm.querySelectorAll(`[data-toggle-if-gt]`).forEach(($input) => {
        const $targetEl = $toggleForm.querySelector(`[name="${$input.dataset.toggleIfGt.split('|')[0]}"]`)
        const targetValue = $input.dataset.toggleIfGt.split('|')[1]
        const $toggleGroup = $input.closest('.toggle-group')

        if ($targetEl && parseInt($targetEl.value, 10) > parseInt(targetValue, 10)) {
          $toggleGroup.classList.remove('hidden')
        }
      })
    }
  },

  handleToggle: (e) => {
    const field = e.target
    const name = e.target.name
    const selectedValue = e.target.value

    if (!$toggleForm) {
      return
    }

    $toggleForm.querySelectorAll(`[data-toggle-if^="${name}|"]`).forEach(($input) => {
      const $toggleGroup = $input.closest('.toggle-group')
      let shouldShow = false

      if (!$toggleGroup) {
        return
      }

      if (field.type === 'radio') {
        const targetValues = $input.dataset.toggleIf.split('|')
        targetValues.shift()
        shouldShow = targetValues.indexOf(selectedValue) !== -1
      }

      if (field.type === 'checkbox') {
        shouldShow = field.checked
      }

      if (shouldShow) {
        $toggleGroup.classList.remove('hidden')
      } else {
        $toggleGroup.classList.add('hidden')

        $toggleGroup.querySelectorAll('input:not([type=checkbox]):not([type=radio])').forEach((x) => (x.value = null))
        $toggleGroup.querySelectorAll('input:checked').forEach((x) => {
          x.checked = false

          $toggleForm.querySelectorAll(`[data-toggle-if^="${x.name}|"]`).forEach(($input) => {
            const $toggleGroup = $input.closest('.toggle-group')
            $toggleGroup.classList.add('hidden')

            $toggleGroup
              .querySelectorAll('input:not([type=checkbox]):not([type=radio])')
              .forEach((x) => (x.value = null))
          })
        })
      }
    })

    $toggleForm.querySelectorAll(`[data-toggle-if-gt^="${name}|"]`).forEach(($input) => {
      const $toggleGroup = $input.closest('.toggle-group')
      let shouldShow = false

      if (!$toggleGroup) {
        return
      }

      if (field.type === 'text') {
        const targetValue = $input.dataset.toggleIfGt.split('|')[1]
        shouldShow = parseInt(selectedValue, 10) > parseInt(targetValue, 10)
      }

      if (shouldShow) {
        $toggleGroup.classList.remove('hidden')
      } else {
        $toggleGroup.classList.add('hidden')

        $toggleGroup.querySelectorAll('input').forEach((x) => (x.value = null))
      }
    })
  },

  setupMasks: async (form) => {
    const fields = form.querySelectorAll('input[type="tel"]')

    if (!fields.length) {
      return
    }

    const { default: IMask } = await import('imask/esm/imask')
    await import('imask/esm/masked/number')
    await import('imask/esm/masked/pattern')

    fields.forEach((field) => {
      if (field.type === 'tel') {
        IMask(field, {
          mask: '(000) 000-0000',
        })
      }
    })
  },
}

export default {
  can: () => true,
  run: fn.init,
}
